import { SVGProps } from "react";

const STIBadoo = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Badoo" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#7000e3" /><path fill="#ff671b" d="M256 160a102 105 0 0 0-183 61c0 92 122 208 183 208s183-116 183-208c0-56-45-102-101-102-33 0-63 15-82 41z" /></svg>;

export { STIBadoo };